class MetadataJSONStorageStatus {
  DRAFT = "DRAFT";
  PENDING = "PENDING";
  PUBLISHED = "PUBLISHED";
}

export default new MetadataJSONStorageStatus();
